<template>
  <div>
    <!-- 搜索表单区域 -->
    <el-form :model="query" label-width="90px" inline size="mini">
      <el-form-item label="资源名称">
        <el-input v-model="query.name" clearable placeholder="请输入资源"></el-input>
      </el-form-item>
      <el-form-item label="资源类型">
        <el-select v-model="query.requestType" clearable placeholder="请选择资源类型">
          <el-option label="菜单" value="1"></el-option>
          <el-option label="请求" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-button type="primary" size="mini" @click="seach">搜索</el-button>
      <!-- <el-button class="reloadBtn" type="warning" size="mini" @click="reload">刷新资源</el-button> -->
    </el-form>
    <!-- 卡片视图区域 -->
    <el-card>
      <!-- 表格数据展示区域 -->
      <el-table :data="permissionList" style="width: 100%" height="650px" border stripe>
        <el-table-column type="index"></el-table-column>
        <el-table-column prop="parentName" label="父资源名称" width="150"></el-table-column>
        <el-table-column prop="name" label="资源名称" width="180"></el-table-column>
        <!-- <el-table-column prop="description" label="资源描述" width="180"></el-table-column> -->
        <el-table-column label="资源类型" width="80">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.requestType === 1">菜单</el-tag>
            <el-tag type="warning" v-else>请求</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="requestUri" label="请求地址"></el-table-column>
        <el-table-column prop="menuIcon" label="菜单图标" width="180"></el-table-column>
        <!-- <el-table-column prop="sequence" label="菜单排序" width="80"></el-table-column> -->
        <!-- <el-table-column prop="createTime" label="创建时间" width="150"></el-table-column> -->
        <el-table-column label="操作" width="260">
          <template slot-scope="scope">
            <el-button :disabled="scope.row.requestType === 2" type="success" size="small" @click="insert(scope.row)">添加子资源</el-button>
            <el-button type="primary" size="small" @click="update(scope.row)">修改</el-button>
            <el-button type="danger" size="small" @click="del(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="pageSizeChange"
        @current-change="CurrentPageChange"
        :current-page="query.curPage"
        :page-sizes="[5, 10, 15]"
        :page-size="query.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-card>

    <!-- 添加子资源对话框 -->
    <el-dialog title="添加子资源" :visible.sync="addDialogVisible" @close="close('addFormRef')" width="35%">
      <el-form :model="addInfo" :rules="addRules" ref="addFormRef" label-width="100px" label-position="left" >
        <el-form-item label="资源名称" prop="name">
          <el-input v-model="addInfo.name"></el-input>
        </el-form-item>
        <el-form-item label="资源描述" prop="description">
          <el-input v-model="addInfo.description"></el-input>
        </el-form-item>
        <el-form-item label="资源地址" prop="requestUri">
          <el-input v-model="addInfo.requestUri"></el-input>
        </el-form-item>
        <el-form-item label="资源类型" prop="requestType">
          <el-select v-model="addInfo.requestType" placeholder="请选择资源类型">
            <el-option label="菜单" value="1"></el-option>
            <el-option label="请求" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="菜单图标" prop="menuIcon">
          <el-input v-model="addInfo.menuIcon"></el-input>
        </el-form-item>
        <el-form-item label="菜单排序" prop="sequence">
          <el-input type="number" v-model="addInfo.sequence"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="insertPermission">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 修改子资源对话框 -->
    <el-dialog title="修改资源" :visible.sync="updateDialogVisible" width="35%">
      <el-form :model="updateInfo" :rules="updateRules" ref="updateFormRef" label-width="100px" label-position="left" >
        <el-form-item label="资源名称" prop="name">
          <el-input v-model="updateInfo.name"></el-input>
        </el-form-item>
        <el-form-item label="资源描述" prop="description">
          <el-input v-model="updateInfo.description"></el-input>
        </el-form-item>
        <el-form-item label="资源地址" prop="requestUri">
          <el-input v-model="updateInfo.requestUri"></el-input>
        </el-form-item>
        <el-form-item label="资源类型" prop="requestType">
          <el-select v-model="updateInfo.requestType" placeholder="请选择资源类型">
            <el-option label="菜单" value="1"></el-option>
            <el-option label="请求" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="菜单图标" prop="menuIcon">
          <el-input v-model="updateInfo.menuIcon"></el-input>
        </el-form-item>
        <el-form-item label="菜单排序" prop="sequence">
          <el-input type="number" v-model="updateInfo.sequence"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="updateDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="updatePermission">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { permissionQuery, permissionInsert, permissionUpdate, permissionDelete } from '@/API/authority'
export default {
  name: 'sysPermission',
  data() {
    return {
      query: {
        curPage: 1,
        pageSize: 10,
        name: '',
        requestType: ''
      },
      // 用户列表
      permissionList: [],
      // 数据总条数
      total: 0,
      addDialogVisible: false,
      addInfo: {
        name: '',
        description: '',
        requestUri: '',
        requestType: '',
        menuIcon: '',
        sequence: 99,
        parentUuid: ''
      },
      addRules: {
        name: [{ required: true, message: '请输入资源名称', trigger: 'blur' }],
        description: [{ required: true, message: '请输入资源描述', trigger: 'blur' }],
        requestUri: [{ required: true, message: '请输入资源地址', trigger: 'blur' }],
        requestType: [{ required: true, message: '请选择资源类型', trigger: 'change' }],
        menuIcon: [{ required: false, message: '请输入菜单图标', trigger: 'blur' }],
        sequence: [{ required: false, message: '请输入菜单排序', trigger: 'blur' }]
      },
      updateDialogVisible: false,
      updateInfo: {
        uuid: '',
        name: '',
        description: '',
        requestUri: '',
        requestType: '',
        menuIcon: '',
        sequence: 99
      },
      updateRules: {
        name: [{ required: true, message: '请输入资源名称', trigger: 'blur' }],
        description: [{ required: true, message: '请输入资源描述', trigger: 'blur' }],
        requestUri: [{ required: true, message: '请输入资源地址', trigger: 'blur' }],
        requestType: [{ required: true, message: '请选择资源类型', trigger: 'change' }],
        menuIcon: [{ required: false, message: '请输入菜单图标', trigger: 'blur' }],
        sequence: [{ required: false, message: '请输入菜单排序', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.queryPermissionList()
  },
  methods: {
    async queryPermissionList() {
      const { data: res } = await permissionQuery(this.query)
      if (res.code !== 200) return this.$message.error(res.message)
      this.permissionList = res.data.entities
      this.total = res.data.totalSize
    },
    // 重置按钮点击事件
    custody() {
      this.query = {
        curPage: 1,
        pageSize: 10
      }
      this.queryPermissionList()
    },
    // 搜索按钮点击事件
    seach() {
      this.query.curPage = 1
      this.queryPermissionList()
    },
    // 监听pageSize
    pageSizeChange(newSize) {
      this.query.pageSize = newSize
      this.queryPermissionList()
    },
    // 监听curPage
    CurrentPageChange(newPage) {
      this.query.curPage = newPage
      this.queryPermissionList()
    },
    reload() {

    },
    insert(row) {
      this.addDialogVisible = true
      this.addInfo.parentUuid = row.uuid
    },
    insertPermission() {
      this.$refs.addFormRef.validate(async valid => {
        if (!valid) return
        const { data: res } = await permissionInsert(this.addInfo)
        if (res.code !== 200) return this.$message.error(res.message)
        this.$message.success(res.message)
        this.$refs.addFormRef.resetFields()
        this.queryPermissionList()
        this.addDialogVisible = false
      })
    },
    update(row) {
      this.updateDialogVisible = true
      this.updateInfo.uuid = row.uuid
      this.updateInfo.name = row.name
      this.updateInfo.description = row.description
      this.updateInfo.requestUri = row.requestUri
      this.updateInfo.requestType = row.requestType + ''
      this.updateInfo.menuIcon = row.menuIcon
      this.updateInfo.sequence = row.sequence
    },
    updatePermission() {
      this.$refs.updateFormRef.validate(async valid => {
        if (!valid) return
        const { data: res } = await permissionUpdate(this.updateInfo)
        if (res.code !== 200) return this.$message.error(res.message)
        this.$message.success(res.message)
        this.$refs.updateFormRef.resetFields()
        this.queryPermissionList()
        this.updateDialogVisible = false
      })
    },
    del(row) {
      this.$confirm('是否删除此资源', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: res } = await permissionDelete({
          uuid: row.uuid
        })
        if (res.code !== 200) return this.$message.error(res.message)
        this.$message.success(res.message)
        this.queryPermissionList()
      })
    },
    close(formRef) {
      this.$refs[formRef].resetFields()
    }
  }
}
</script>

<style lang="less" scoped>
.resetBtn {
  margin-left: 50px;
}
.addBtn {
  float: right;
  margin-right: 20px;
}
.reloadBtn {
  float: right;
  margin-right: 50px;
}
</style>
